import React from 'react';

type SelectionHandlers = {
  setSelectedAnnotations: (ids: string[]) => void;
  toggleAnnotationSelection: (annotationId: string) => void;
  createRelations: (pairs: { left: string; right: string }[]) => void;
  focusAnnotation: (id: string) => void;
  addToChainNesting: (annotationId: string) => void;
};

export function handleAnnotationClick(
  annotationId: string,
  e: React.MouseEvent,
  selectedAnnotations: string[],
  chainNestingActive: boolean,
  handlers: SelectionHandlers,
) {
  const isCmdOrCtrl = e.metaKey || e.ctrlKey;

  if (isCmdOrCtrl && e.shiftKey) {
    if (!chainNestingActive && selectedAnnotations.length > 0) {
      // Multi-select nesting: nest all selected under target
      const sources = selectedAnnotations.filter(id => id !== annotationId);
      if (sources.length > 0) {
        handlers.createRelations(
          sources.map(sourceId => ({ left: sourceId, right: annotationId })),
        );
        handlers.setSelectedAnnotations([]);
        handlers.focusAnnotation(annotationId);
      }
    } else {
      // Chain nesting mode: add to chain
      handlers.addToChainNesting(annotationId);
      handlers.focusAnnotation(annotationId);
    }
  } else if (isCmdOrCtrl) {
    handlers.toggleAnnotationSelection(annotationId);
    if (selectedAnnotations.indexOf(annotationId) < 0) {
      handlers.focusAnnotation(annotationId);
    }
  }
}
